<template>
<div class="user_mm no-trans" v-loading="loading">
    <div class="page_name">
        <div class="name">发票管理</div>
        <div class="btns" @click="handle_add()">
            <img src="../../../../assets/img/user_info/user_gl/add_fp.png" alt="">
            新增发票抬头
        </div>
    </div>
    <div class="info_box">
        <div class="info_titles">电子发票信息</div>
        <div class="fp_list">
            <div class="list_item" v-for="(item,index) in list" :key="index">
                <div class="item_lefts">
                    <div class="names" v-if="item.type==1">{{ item.taitou }}</div>
                    <div class="names" v-if="item.type==2">{{ item.company }}</div>
                    <div class="codes">税号：{{ item.taxpayer_number }}</div>
                </div>
                <div class="item_right">
                    <div class="btns1" @click="handle_xg(item)">修改</div>
                    <div class="btns2" @click="handle_clear(item)">删除</div>
                </div>
            </div>
        </div>
        <div class="pages_box"  v-if="total!=0">
            <div class="btns" @click="handle_pages(1)">首页</div>
            <site-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pages.page"
                background
                :page-size="pages.limit"
                layout="prev, pager, next"
                :total="total">
            </site-pagination>
            <div class="btns"  @click="handle_pages(last_page)">尾页</div>
        </div>
    </div>
   
    
    
</div>
</template>
<script>
import { mapState} from 'vuex'
 


export default {
    components: {
        
    },
    name: "homes",
    data() {
        return {
            loading: false,
            list:[],
            total:0,
            last_page:0,
            pages:{
                page:1,
                limit:10,
            },
           
        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        this.get_list()
    },
    methods: {
        handle_add(){
            this.$router.push({
                path:'/user_gl/user_gl_detial',
                query:{
                },
            }) 
        },
        handle_xg(item){
            this.$router.push({
                path:'/user_gl/user_gl_detial',
                query:{
                    id:item.id
                },
            })
        },
        handle_clear(item){
            this.$confirm('是否删除该发票?', '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning'
            }).then(() => {
                this.fp_clear_end(item)
            }).catch(() => {
                 
            });
        },
        fp_clear_end(item){
            this.$api("invoiceDel", {
                id:item.id
			}, "get").then((res) => {
                this.loading = false
                console.log('发票删除',res)
                if (res.code == 1) {
                    alertSucc('删除成功')
                    this.pages.page=1
                    this.get_list()
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handleSizeChange(e){
            console.log('条数',e)            
        },
        handleCurrentChange(e){
            console.log('页数',e)
        },
        handle_pages(i){
            console.log('首页尾页',i)
            this.pages.page=i
        },
        get_list(){
            this.$api("invoiceList", {
                ...this.pages,
			}, "get").then((res) => {
                this.loading = false
                console.log('发票列表',res)
                if (res.code == 1) {
                    this.list=res.data.data
                    this.total=res.data.total
                    this.last_page=res.data.last_page
                } else {
                    alertErr(res.msg)
                }
            });
        },



    },

}
</script>
<style scoped lang="less">
.user_mm {  
    .page_name{
        width: 1196px;
        height: 56px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        padding: 0 32px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .name{
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            font-size: 16px;
            color: #333333;
        }
        .btns{
            display: flex;
            align-items: center;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #377CFD;
            cursor: pointer;
            img{
                width: 18px;
                margin-right: 10px;
            }
        }


    }
    .info_box{
        width: 1196px;
        min-height: 700px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        margin-top: 18px;
        padding: 29px 32px 33px 32px;
        .info_titles{
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            font-size: 16px;
            color: #333333;
        }
        .fp_list{
            padding-top: 22px;
            .list_item{
                width: 1133px;
                height: 102px;
                background: #FFFFFF;
                border-radius: 0px 0px 0px 0px;
                border: 1px solid #CCCCCC;
                margin-bottom: 20px;
                padding: 26px 20px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .item_lefts{
                    height: 100%;
                    display: flex;
                    align-content: space-between;
                    flex-wrap: wrap;
                    .names{
                        width: 100%;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #333333;

                    }
                    .codes{
                        width: 100%;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #333333;
                    }
                }
                .item_right{
                    display: flex;
                    align-items: center;
                    .btns1{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #377CFD;
                        cursor: pointer;

                    }
                    .btns2{
                        margin-left: 32px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #FD4C5C;
                        cursor: pointer;
                    }
                }
                

            }
        }
    }
    .pages_box{
                width: 100%;
                height: 100px;
                // background-color: red;
                display: flex;
                align-items: center;
                justify-content: end;
                /deep/.el-pagination{
                    .btn-prev{
                        background-color: #FFFFFF;
                        border: 1px solid #EEEEEE;  
                        
                    }
                    .el-pager{
                        .number {
                            background-color: #FFFFFF;
                            border: 1px solid #EEEEEE;  

                        }
                        .active{
                            background-color: #377CFD;
                        }
                        .el-icon{
                            background-color: #FFFFFF;
                        }
                    }
                    .btn-next{
                        background-color: #FFFFFF;
                        border: 1px solid #EEEEEE;  

                    }
                }
                .btns{
                    width: 40px;
                    height: 32px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #EEEEEE;  
                    font-family: PingFang-SC-Medium, PingFang-SC-Medium;
                    font-weight: normal;
                    font-size: 14px;
                    color: #7A7A7A;
                    text-align: center;
                    line-height: 32px;
                    cursor: pointer;
                }
            }
}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .user_mm.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    .user_mm.no-trans .page_name {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 0px 0px 0px 0px;
        padding: 0 16px;
        flex-wrap: wrap;
        gap: 8px;
        min-height: 44px;
    }
    .user_mm.no-trans .page_name .name {
        font-size: 16px;
    }
    .user_mm.no-trans .page_name .btns {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .user_mm.no-trans .page_name .btns img {
        width: 18px;
        margin-right: 10px;
    }
    .user_mm.no-trans .info_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        border-radius: 0px 0px 0px 0px;
        margin-top: 16px;
        padding: 16px 16px 16px 16px;
    }
    .user_mm.no-trans .info_box .info_titles {
        font-size: 16px;
    }
    .user_mm.no-trans .info_box .fp_list {
        padding-top: 16px;
    }
    .user_mm.no-trans .info_box .fp_list .list_item {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        border-radius: 0px 0px 0px 0px;
        margin-bottom: 16px;
        padding: 16px 16px;
        flex-wrap: wrap;
        gap: 8px;
    }
    .user_mm.no-trans .info_box .fp_list .list_item .item_lefts {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_mm.no-trans .info_box .fp_list .list_item .item_lefts .names {
        font-size: 14px;
    }
    .user_mm.no-trans .info_box .fp_list .list_item .item_lefts .codes {
        font-size: 14px;
    }
    .user_mm.no-trans .info_box .fp_list .list_item .item_right {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_mm.no-trans .info_box .fp_list .list_item .item_right .btns1 {
        font-size: 14px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .user_mm.no-trans .info_box .fp_list .list_item .item_right .btns2 {
        margin-left: 16px;
        font-size: 14px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .user_mm.no-trans .pages_box {
        min-height: 0;
        height: auto;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_mm.no-trans .pages_box .btns {
        width: 40px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        line-height: 1.6;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
}
</style>
